import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageDialogComponent } from '@app/shared/message-dialog/message-dialog.component';
import { ExperienceLibraryService } from '@app/core/services/experience-library.service';
import { SessionService } from '@app/security/session.service';
import { take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { interval, of } from 'rxjs';
import { switchMap, takeWhile, catchError } from 'rxjs/operators';
import { UploadDropAreaComponent } from '../../file-launcher/components/upload-drop-area/upload-drop-area.component';
import { MessageDialogComponent as MessageDialogComponent_1 } from '../../shared/message-dialog/message-dialog.component';

@Component({
    selector: 'rn-experience-import',
    templateUrl: './experience-import.component.html',
    styleUrls: ['./experience-import.component.scss'],
    standalone: true,
    imports: [UploadDropAreaComponent, MessageDialogComponent_1],
})
export class ExperienceImportComponent implements OnInit {
  @ViewChild(MessageDialogComponent, { static: true })
  messageDialog: MessageDialogComponent;
  experienceFile: File = null;
  validationMessage: string = '';
  validationErrorMessages: string[] = [];
  isValid: boolean = false;
  isLoading: boolean = false;

  constructor(
    private experienceLibraryService: ExperienceLibraryService,
    private router: Router,
    private sessionService: SessionService,
  ) {}

  ngOnInit(): void {}

  fileReUploaded(event) {
    if (event.target['files'].length > 0) {
      this.handleDropImport(event.target['files'][0]);
      event.target.value = '';
    }
  }

  async handleDropImport(file: File) {
    this.validationMessage = '';
    this.isValid = true;
    this.experienceFile = file;
  }

  submitExperienceImport() {
    const clientId = this.sessionService.getCurrentUsersClient().id;
    this.isLoading = true;
    this.experienceLibraryService
      .importExperience(clientId, this.experienceFile)
      .pipe(take(1))
      .subscribe(
        (result) => {
          const importId = result.importId;
          interval(2000)
            .pipe(
              switchMap(() =>
                this.experienceLibraryService
                  .getImportStatus(clientId, importId)
                  .pipe(
                    catchError((err) => {
                      if (err?.error?.error) {
                        return of({
                          status: 'error',
                          error: [{ message: err.error.error }],
                        });
                      }
                      return of({
                        status: 'error',
                        error: [{ message: 'Unknown error' }],
                      });
                    }),
                  ),
              ),
              takeWhile(
                (statusResp: any) =>
                  statusResp.status !== 'completed' &&
                  statusResp.status !== 'failed' &&
                  statusResp.status !== 'error',
                true,
              ),
            )
            .subscribe((statusResp: any) => {
              if (statusResp.status === 'completed') {
                this.isLoading = false;
                this.router.navigateByUrl(
                  `/cx-builder/experience-builder/${statusResp.experienceId}`,
                );
              } else if (
                statusResp.status === 'failed' ||
                statusResp.status === 'error'
              ) {
                this.isLoading = false;
                let errorMessages: string[] = [];
                if (Array.isArray(statusResp.error)) {
                  errorMessages = statusResp.error.map((e: any) => e.message);
                } else if (typeof statusResp.error === 'string') {
                  errorMessages = [statusResp.error];
                } else {
                  errorMessages = ['An error occurred during import.'];
                }
                this.validationErrorMessages = errorMessages;
                this.isValid = false;
              }
            });
        },
        (error: any) => {
          this.isLoading = false;
          const msg =
            error?.message ||
            (error?.statusText
              ? `${error.status} ${error.statusText}`
              : 'An error occurred during file upload.');
          this.messageDialog.showMessage(msg);
        },
      );
  }

  removeExperiencePackage() {
    this.validationMessage = '';
    this.experienceFile = null;
    this.isValid = false;
  }

  showExperiencePackageDetails() {
    return this.experienceFile !== null;
  }

  backToExperienceBuilder() {
    this.router.navigateByUrl('/cx-builder');
  }
}
